















































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Ability } from '@/types/Ability'
import ErrorDisplay from '@/components/ErrorDisplay.vue'
import EditorTinyMCE from '@/components/Tools/EditorTinyMCE.vue'
import { displayGroupPublishableToString, display_interface_publishable } from '@/types/Publishable'
import { type_publishable_message } from '@/types/PublishableMessage'

@Component({
    computed: {
        ...mapGetters('candidat', ['candidats', 'loading', 'totalRows', 'lastPage', 'totalPage']),
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapGetters('publishableMessage', ['publishableMessages', 'publishables', 'loading', 'error'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        ErrorDisplay,
        EditorTinyMCE
    }
})

export default class Parametrage extends Vue
{
    loadingData = false
    publishableSelected: any = null
    publishableMessageSelected: any = null
    Ability = Ability
    toolbarAnnexe = 'bold italic underline | link'
    tollbarAnnexe_pdf = 'table | bold italic underline | link'
    useOnAllForm = false

    showModalMessagechangeWithoutSaving = false

    publishableMessageTemp = ''

    publiWait = null
    publishableMessageSelectedWait = null
    display_interface_publishable = display_interface_publishable
    type_publishable_message = type_publishable_message

    @Watch('publishableMessageSelected')
    publishableMessageSelectedChangeHandler(value: any, oldValue: any) {
        if (this.publishableMessageSelectedWait === null) {
            if (oldValue && value) {
                const oldPublishableMessageSelected = this.$store.getters['publishableMessage/getPublishableMessage_by_id'](oldValue.id)
                if (oldValue.id !== value.id &&
                    this.cleanHtml(this.publishableMessageTemp) !== '' &&
                    oldPublishableMessageSelected &&
                    (this.publishableMessageTemp !== oldPublishableMessageSelected.content &&
                        this.cleanHtml(this.publishableMessageTemp) !== oldPublishableMessageSelected.content))  {
                    this.publishableMessageSelectedWait = value
                    this.publishableMessageSelected = oldValue
                    this.showModalMessagechangeWithoutSaving = true
                    // console.log('---this.publishableMessageTemp : ' + this.cleanHtml(this.publishableMessageTemp))
                    // console.log('---this.publishableMessageSelected.content : ' + this.publishableMessageSelected.content)
                } else {
                    this.publishableMessageTemp = ''
                    this.publishableMessageSelected = value
                    this.useOnAllForm = false
                }
            }
        }
    }


    displayGroupPublishableToString = displayGroupPublishableToString

    cancelChangeWithoutSaving () {
        this.showModalMessagechangeWithoutSaving = false
        this.publishableMessageSelectedWait = null
    }

    confirmChangeWithoutSaving () {
        this.showModalMessagechangeWithoutSaving = false
        if (this.publiWait) {
            this.publishableMessageTemp = ''
            this.publishableSelected = this.publiWait
            if (this.publishableMessageSelected) {
                for (let i = 0; i < this.publishableSelected.publishableMessages.length; i++) {
                    if (this.publishableSelected.publishableMessages[i].code ===  this.publishableMessageSelected.code) {
                        this.publishableMessageSelected = this.publishableSelected.publishableMessages[i]
                    }
                }
            }
            // this.publishableMessageSelected = null
            this.publiWait = null
        } else if (this.publishableMessageSelectedWait) {
            this.publishableMessageTemp = ''
            this.publishableMessageSelected = this.publishableMessageSelectedWait
            this.publishableMessageSelectedWait = null
        }
        this.useOnAllForm = false
    }

    savePublishableMessageSelected (value: string) {
        this.publishableMessageTemp = value
    }

    cleanHtml (content: string) {
        const txt = document.createElement('textarea')
        txt.innerHTML = content
        const test = txt.value.replace(/<[^>]+>/gm, '')
        // test = test.replace(/<br>/gm, '')
        return test
    }


    changePublishable (publi: any) {
        if (!this.publishableMessageSelected ||
            this.cleanHtml(this.publishableMessageTemp) === '' ||
            this.publishableMessageTemp === this.publishableMessageSelected.content ||
            this.cleanHtml(this.publishableMessageTemp) === this.publishableMessageSelected.content) {
            this.publishableMessageTemp = ''
            this.publishableSelected = publi
            let found = false
            if (this.publishableMessageSelected) {
                for (let i = 0; i < this.publishableSelected.publishableMessages.length; i++) {
                    if (this.publishableSelected.publishableMessages[i].code ===  this.publishableMessageSelected.code) {
                        found = true
                        this.publishableMessageSelected = this.publishableSelected.publishableMessages[i]
                    }
                }
            }
            this.useOnAllForm = false
            if (!found) {
                this.publishableMessageSelected = null
            }
        } else {
            // console.log('---this.publishableMessageTemp : ' + this.cleanHtml(this.publishableMessageTemp))
            // console.log('---this.publishableMessageSelected.content : ' + this.publishableMessageSelected.content)
            this.showModalMessagechangeWithoutSaving = true

            this.publiWait = publi
        }
    }

    save() {
        if (this.publishableMessageSelected && this.publishableMessageSelected.id) {
            const payload = {
                id: this.publishableMessageSelected.id,
                content: this.publishableMessageTemp,
                type: this.publishableMessageSelected.type,
                applyall: this.useOnAllForm ? '1' : '0' // 1
            }
            const idInfo = 't_info_' + Math.random()
            const infosToaster = {
                id: idInfo,
                toaster: 'b-toaster-top-right',
                variant: 'primary',
                noCloseButton: true,
                fade: true,
                noAutoHide: true
            }

            this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
            this.$store.dispatch('publishableMessage/updatePublishableMessage', payload)
                .then(async () => {
                    const idSucces = 't_succes_' + Math.random()
                    const succesToaster = {
                        id: idSucces,
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                        noCloseButton: true,
                        fade: true,
                        autoHideDelay: 5000
                    }
                    this.$bvToast.toast('Enregistrement terminé.', succesToaster)
                    this.loadingData = true
                    this.publishableMessageSelected.content = this.publishableMessageTemp
                    this.useOnAllForm = false
                    await this.$store.dispatch('publishableMessage/getPublishableMessages')
                    this.loadingData = false
                }).catch((error) => {
                    console.log('ko:' + error)
                })
                .finally(() => {
                    this.$bvToast.hide(idInfo)
                })
        }
    }

    cancel() {
        console.log('cancel')
    }

    mounted() {
        this.loadingData = true
        this.$store.dispatch('publishableMessage/getPublishableMessages').then(() => {
            this.loadingData = false
            this.publishableSelected = this.$store.getters['publishableMessage/publishables'][0]
        })
    }
}
